import React from 'react';

import api from '../../assets/icons/api.svg'
import backend from '../../assets/icons/backend.svg'
import algo from '../../assets/icons/algo.svg'
import computer from '../../assets/icons/computer.svg'
import repair from '../../assets/icons/repair.svg'
import puzzle from '../../assets/icons/puzzle.svg'


const skills = [
    {
        icon: computer,
        title: "Frontend Development",
        about: "I can make a beautiful looking UI/UIX using REACTJS"
    },
    {
        icon: repair,
        title: "Backend  Development",
        about: "I'm Quite Used To Backend Development Using MYSQL,Laravel,PHP,MariaDB,NOSQL",
    },
    {
        icon: api,
        title: "API Development",
        about: "I Always Develop API Using REST-API"
    },
    {
        icon: algo,
        title: "Competitive Coder",
        about: "a daily problem solver in my projects mostly eliminating bugs"
    },
    {
        icon: puzzle,
        title: "UI/UX designer",
        about: "Minimal user interface designing using figma"
    },
    {
        icon: computer,
        title: "Hacker",
        about: "I'm An Ethical Hacker in Hackerone, BugCrowd, Bugbounty.JP and some other bug bounty programs too"
    },
]

export default skills;